import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "sealEditor",
  novalidate: "",
  class: "tray-theme-editor__seal-editor",
  enctype: "multipart/form-data"
}
const _hoisted_2 = { class: "tray-theme-editor__seal-editor__header" }
const _hoisted_3 = { class: "tray-theme-editor__seal-editor__actions" }
const _hoisted_4 = { class: "tray-theme-editor__seal-editor__actions-wrapper" }
const _hoisted_5 = { class: "tray-theme-editor__seal-editor__actions-title" }
const _hoisted_6 = { class: "tray-theme-editor__input-file" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = {
  ref: "contentSeal",
  class: "tray-theme-editor__seal-editor__content"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputStandardImages = _resolveComponent("InputStandardImages")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Icon, {
            "test-id": "btn-back",
            name: "arrow-left",
            prefix: "fa",
            "aria-hidden": "true",
            onClick: _ctx.emitEventSetComponent
          }, null, 8, ["onClick"]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('layout-editor.edit-options')), 1)
        ]),
        _createVNode(_component_Icon, {
          "test-id": "btn-close",
          name: "times-circle",
          "aria-hidden": "true",
          onClick: _ctx.emitEventClose
        }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("fieldset", _hoisted_6, [
      _createElementVNode("legend", {
        class: "tray-theme-editor__seal-editor__title",
        "aria-label": _ctx.$t('layout-editor.seals')
      }, _toDisplayString(_ctx.$t('layout-editor.seals')), 9, _hoisted_7),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageListSeals, (image, index) => {
          return (_openBlock(), _createBlock(_component_InputStandardImages, {
            key: index,
            "test-key": image.key,
            "input-fields": {
            label: _ctx.$t(`components.seal.inputs-file.${image.key}.title`),
            field: _ctx.$t(`components.seal.inputs-file.${image.key}.name`),
            description: [
              _ctx.$t(`components.seal.inputs-file.${image.key}.tooltip-info`),
            ],
            validation: '',
            type: '',
          },
            "url-image": image.url,
            onCallback: _ctx.updateImage
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 2
          }, 1032, ["test-key", "input-fields", "url-image", "onCallback"]))
        }), 128))
      ], 512)
    ])
  ], 512))
}